export default "__VITE_ASSET__fV1K6vNX__"